import React, { useEffect, useState, useContext, useMemo } from 'react';
import { MessageContext } from './MessageContext';
import IntroductionContent from './IntroductionContent';

const PromptExample = ({ role, todo, navigationExamples, clickShowAnalysis }) => {
    const { setSelectedMessage } = useContext(MessageContext);
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const [currentCharIndex, setCurrentCharIndex] = useState(0);
    const [displayedMessages, setDisplayedMessages] = useState([]);
    const [messages, setMessages] = useState([]);
    
    const getRoleName = (role) => {
        if (role === "all") {
            return role;
        } else {
            return 'for-' + role; 
        }
    }
  
    // フィルタリングしてランダムに4つの例を取得する
    useEffect(() => {
        const examples = navigationExamples.filter(prompt => prompt.role === getRoleName(role) && prompt.todo === todo);
        const randomExamples = examples.sort(() => 0.5 - Math.random()).slice(0, 4);
        setMessages(randomExamples.map(prompt => prompt.question));
        setDisplayedMessages([]); 
        setCurrentMessageIndex(0); // メッセージ表示をリセット
        setCurrentCharIndex(0); // 文字表示をリセット
    }, [role, todo, navigationExamples]);

    // 文字を1つずつ表示する処理
    useEffect(() => {
        if (messages.length > 0 && currentMessageIndex < messages.length) {
            const currentMessage = messages[currentMessageIndex];

            if (currentCharIndex < currentMessage.length) {
                const timer = setTimeout(() => {
                    const updatedMessage = currentMessage.slice(0, currentCharIndex + 1);
                    setDisplayedMessages(prevMessages => {
                        const newMessages = [...prevMessages];
                        newMessages[currentMessageIndex] = updatedMessage;
                        return newMessages;
                    });
                    setCurrentCharIndex(prev => prev + 1);
                }, 2); // 文字が2ミリ秒ごとに表示される
                return () => clearTimeout(timer);
            } else {
                // 1つのメッセージが完了したら次のメッセージへ
                setCurrentMessageIndex(prev => prev + 1);
                setCurrentCharIndex(0);
            }
        }
    }, [messages, currentMessageIndex, currentCharIndex]);

    const analyzeSteps = useMemo(() => {
        const stepMessages = {
            analyzeCompany: '企業の分析手順を知りたい',
            compareCompanies: '企業比較の手順を知りたい',
            analyzeIndustry: '業界の分析手順を知りたい',
        };

        const stepMessage = stepMessages[todo];
        if (stepMessage) {
            return (
                <div className="help-analysis" data-value={`${todo}`} onClick={() => clickShowAnalysis(todo)}>
                    {stepMessage}
                </div>
            );
        } else {
            return null;
        }
    }, [todo]);

  return (
      <>
          <div className='help-prompt'>
              <div className="prompt-msg"><i className="fa-regular fa-lightbulb"></i>プロンプトの例です</div>
          {analyzeSteps}
          <div className='prompt-example-container first-introduction'>
              {displayedMessages.map((message, index) => (
                  <IntroductionContent key={index} message={message} onClick={() => setSelectedMessage(message)} addClass="prompt-example" />
              ))}
          </div>
      </div>
      </>
    );
};

export default PromptExample;
